import { Component } from '@angular/core';

@Component({
  selector: 'app-student-counselling-report-landing',
  templateUrl: './student-counselling-report-landing.component.html',
  styleUrls: ['./student-counselling-report-landing.component.scss']
})
export class StudentCounsellingReportLandingComponent {

}
